<template>
  <div>
    <el-row>
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true">
          <el-form-item label="领料部门：">
            <el-select size="medium" filterable v-model="searchForm.department" style="width: 200px" :clearable="true">
              <el-option v-for="item in departmentList" :key="item.ID" :value="item.ID" :label="item.DEPARTMENT_NAME">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="领料日期：">
            <el-date-picker size="medium" v-model="searchForm.DAY_INTERVAL" type="daterange" align="right" unlink-panels
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
              value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item label="操作日期：">
            <el-date-picker size="medium" v-model="searchForm.DELIVER_DAY" type="daterange" align="right" unlink-panels
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
              value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" class="btn" @click="handleCurrentChangeSearch()">筛选</el-button>
            <el-button size="medium" type="primary" plain class="btn" @click="exportPickingDoc">导出</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row style="margin-bottom: 20px;">
      <el-col>
        <el-button size="medium" @click="gotoProPickingProduct" type="primary">生产领料</el-button>
        <el-button size="medium" @click="gotoPurchaseProduct" type="primary">销售转生产领料</el-button>
        <el-button size="medium" @click="importProPickingDetailVisible = true" v-show="fun_dic[124010001]">导入领料详情
        </el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" border stripe>
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column prop="REQUISITIONER" label="领料人"></el-table-column>
          <el-table-column prop="DEPARTMENT_NAME" label="领料部门"></el-table-column>
          <el-table-column prop="SEND_DAY" label="领料时间"></el-table-column>
          <el-table-column prop="TOTAL_FEE" label="领料总金额"></el-table-column>
          <el-table-column prop="CREATE_TIME" label="创建时间"></el-table-column>
          <el-table-column>
            <template slot-scope="scope">
              <el-button type="text" @click="openDetail(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </el-col>
    </el-row>
    <!-- 导入领料详情 -->
    <el-dialog title="导入领料详情" center :visible.sync="importProPickingDetailVisible" width="500px">
      <el-form ref="importForm" v-model="importForm" style="margin-left: 30px">
        <el-upload class="upload-demo" action="/uploadFile" ref="upload" :on-success="handleSuccess"
          :on-remove="handleRemove" :name="this.importForm.file" multiple :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
        <p style="color: #409eff" @click="downloadTmp">点击下载导入模板</p>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="importProPickingDetailVisible = false">取 消</el-button>
        <el-button @click="importProPickingDetail">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getDocFun, exportPickingDocFun } from 'api/proDepartment';
import { queryDepartment } from 'api/productDepart';
import { getActionFun } from 'api/login';
import http from '@/assets/common/http';

export default {
  data() {
    return {
      tableData: [],
      searchForm: {},
      departmentList: [],
      pickerOptions: [],
      currentPage: 1,
      pageSize: 10,
      totalCount: 10,
      fileList: [],
      importProPickingDetailVisible: false,
      importForm: {
        file: 'tmp',
      },
      PAGE_ID: '1240100', // 页面ID 一旦规定不要轻易改动
      fun_dic: { 124010001: 0 },
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (JSON.stringify(this.PRO_PICKING_DOC_LIST) != '{}' && this.PRO_PICKING_DOC_LIST != undefined) {
      this.searchForm = this.PRO_PICKING_DOC_LIST.CONDITION;
      this.currentPage = this.PRO_PICKING_DOC_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryData();
    this.queryDepartment();
    this.queryBeforeFun();
  },
  computed: {
    PRO_PICKING_DOC_LIST() {
      return this.$store.state.SAVE_PRO_PICKING_DOC;
    },
  },
  methods: {
    handleCurrentChangeSearch() {
      this.currentPage = 1;
      this.queryData();
    },
    queryDepartment() {
      queryDepartment().then((res) => {
        this.departmentList = res;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    queryData() {
      const params = {
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
      };
      if (this.searchForm.department) {
        params.DEPARTMENT_ID = this.searchForm.department;
      }
      if (this.searchForm.DAY_INTERVAL) {
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      }
      if (this.searchForm.DELIVER_DAY) {
        params.DELIVER_START_DAY = this.searchForm.DELIVER_DAY[0];
        params.DELIVER_END_DAY = this.searchForm.DELIVER_DAY[1];
      }
      getDocFun(params).then((res) => {
        if (res[0]) {
          this.tableData = res[0].list;
          this.totalCount = res[0].TOTAL_COUNT;
          this.$store.dispatch('SET_SAVE_PRO_PICKING_DOC', {
            CONDITION: this.searchForm,
            CURRENT_PAGE: this.currentPage,
          });
        } else {
          this.tableData = [];
          this.totalCount = 0;
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    openDetail(row) {
      this.$router.push({ path: '/proPickingDocDetail/detail' });
      sessionStorage.setItem('orderID', row.ID);
      sessionStorage.setItem('titleData', JSON.stringify(row));
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryData();
    },
    exportPickingDoc() {
      const params = {};
      if (this.searchForm.department) {
        params.DEPARTMENT_ID = this.searchForm.department;
      }
      if (this.searchForm.DAY_INTERVAL) {
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      }
      if (this.searchForm.DELIVER_DAY) {
        params.DELIVER_START_DAY = this.searchForm.DELIVER_DAY[0];
        params.DELIVER_END_DAY = this.searchForm.DELIVER_DAY[1];
      }
      exportPickingDocFun(params).then((res) => {
        window.location.href = this.$util.getURLLocalHost(res[0].FILE_PATH);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    gotoProPickingProduct() {
      this.$router.push({ path: '/proPickingProduct' });
    },
    gotoPurchaseProduct() {
      this.$router.push({ path: '/purchaseProduct' });
    },
    handleSuccess(response, file, fileList) {
      this.url = response.file_name;
    },
    handleRemove(file, fileList) {
      this.fileList = [];
      this.url = '';
    },
    downloadTmp() {
      window.location.href = 'https://service.linkda.com.cn/file/templates/proPickingDetailTemp.xls';
    },
    importProPickingDetail() {
      if (!this.url) {
        this.$message.show({ text: '请上传文件', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '10055',
        OTYPE: 10,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        FILE_NAME: this.url,
      };
      http.post(params)
        .then((result) => {
          if (result[0].FILE_PATH == '') {
            this.$message.show({ text: '导入成功', type: 'success' });
            this.url = '';
            this.$refs.upload.clearFiles();
            this.importProPickingDetailVisible = false;
            this.fileList = [];
            this.queryData();
            document.body.style.cursor = 'default';
          } else {
            this.$message.show({ text: '导入异常，详情查看下载文件', type: 'error' });
            this.url = '';
            this.$refs.upload.clearFiles();
            this.importProPickingDetailVisible = false;
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
            this.fileList = [];
            document.body.style.cursor = 'default';
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
          this.url = '';
          this.$refs.upload.clearFiles();
          document.body.style.cursor = 'default';
        });
    },
    // 控制功能按钮
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      getActionFun(params)
        .then((result) => {
          if (result.length !== 0) {
            this.forMenu(result, this.fun_dic);
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    forMenu(e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/productionProcessing/proPickingDoc.vue